import React from 'react'
import { graphql } from 'gatsby'
import BlogTemplate from 'src/components/templates/blog-template.js'

const title = 'commmuneブログ'
const description =
  'commmune(コミューン)のブログです。国内外のオンライン顧客接点(ユーザーコミュニティ)におけるコミュニティマーケティングの成功事例やコンテンツを展開しています。'

const pageTitle = 'ブログ'
const pageHeading = 'BLOG'

const Blog = ({ data: { allMarkdownRemark }, location }) => {
  return (
    <BlogTemplate
      title={title}
      description={description}
      pageTitle={pageTitle}
      pageHeading={pageHeading}
      allMarkdownRemark={allMarkdownRemark}
      location={location}
    />
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/blog/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
      edges {
        node {
          id
          frontmatter {
            title
            tags
            date(formatString: "YYYY.MM.DD")
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt(truncate: true)
        }
      }
    }
  }
`

export default Blog
